"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
interface ReturnValues {
  value: boolean;
  setTrue: () => void;
  setFalse: () => void;
  setValue: (value: boolean) => void;
  toggle: () => void;
}
export const useBoolean = t0 => {
  const $ = _c(7);
  const defaultValue = t0 === undefined ? false : t0;
  const [value, setValue] = useState(defaultValue);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setValue(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setTrue = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setValue(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const setFalse = t2;
  let t3;
  if ($[2] !== value) {
    t3 = () => {
      setValue(!value);
    };
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const toggle = t3;
  let t4;
  if ($[4] !== toggle || $[5] !== value) {
    t4 = {
      value,
      setTrue,
      setFalse,
      setValue,
      toggle
    };
    $[4] = toggle;
    $[5] = value;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};